/* global axios */
import ApiClient from './ApiClient';

class DocumentTemplatesAPI extends ApiClient {
  constructor() {
    super('document_templates', { accountScoped: true });
  }

  // Render the template filled with sample/real data as HTML (no persistence).
  // `body`/`pageConfig` (optional) override the saved row in memory so the preview
  // reflects the editor's current, possibly-unsaved, state (e.g. a just-changed
  // paper size). They are never persisted by this endpoint.
  preview(id, { generableType, generableId, body, pageConfig } = {}) {
    return axios.post(`${this.url}/${id}/preview`, {
      generable_type: generableType,
      generable_id: generableId,
      document_template: { body, page_config: pageConfig },
    });
  }

  // Render + store a PDF for the given host record, returning the GeneratedDocument.
  generate(id, { generableType, generableId } = {}) {
    return axios.post(`${this.url}/${id}/generate`, {
      generable_type: generableType,
      generable_id: generableId,
    });
  }
}

export default new DocumentTemplatesAPI();
